import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import Api from '@/config/api.helper'

export const useSaldoConta = defineStore('saldoConta', () => {
  const saldo = ref(0)
  const loadingSaldo = ref(false)
  const lastUpdateTime = ref(0)
  const SALDO_MINIMO = 0.59

  const saldoBaixo = computed(() => saldo.value <= SALDO_MINIMO)

  const podeUsarCreditos = computed(() => saldo.value > SALDO_MINIMO)

  async function updateSaldo(force = false) {
    if (!force && saldo.value > 0) {
      return
    }

    loadingSaldo.value = true
    try {
      const response = await Api.get('empresas/creditos/saldo')
      const novoSaldo = response.data.emp_saldo
      saldo.value = novoSaldo
      lastUpdateTime.value = Date.now()

      if (novoSaldo <= SALDO_MINIMO) {
        console.warn(`Saldo baixo detectado: R$ ${novoSaldo.toFixed(2)}`)
      }
    } catch (error) {
      console.error('Não foi possível carregar o saldo:', error)
    } finally {
      loadingSaldo.value = false
    }
  }

  function setSaldo(valor: number) {
    saldo.value = valor
    lastUpdateTime.value = Date.now()
  }

  function verificarSaldoParaAcao(): boolean {
    return saldo.value > SALDO_MINIMO
  }

  function getMensagemSaldoInsuficiente(): string {
    return `Seu bônus inicial acabou. Para continuar utilizando a plataforma, envie seus documentos para análise e libere o acesso a todos os módulos do sistema.`
  }

  return {
    saldo,
    loadingSaldo,
    saldoBaixo,
    podeUsarCreditos,
    SALDO_MINIMO,
    updateSaldo,
    setSaldo,
    verificarSaldoParaAcao,
    getMensagemSaldoInsuficiente,
  }
})
